export function checkPhone(value) {
    const isPhone = /^(09)[0-9]{8}$/;
    return isPhone.test(value)
}

export function checkPhoneByCountryCode(phone, countryCode) {
    if (countryCode === "+886") {
        return checkPhone(phone);
    } else if (countryCode !== "+886" && (phone.length > 3 && (phone.length + countryCode.length-1<21))){
        const isPhone = new RegExp(`^[0-9]{${phone.length}}$`);
        return isPhone.test(phone);
    } else {
        return false;
    }
}

export function checkPassword(value) {
    const passwordRule = /(?=.*\d)(?=.*[A-Za-z]).{6,12}$/
    return passwordRule.test(value)
}

export function checkSpecialChars(userInput) {
    const pattern = /[<>/;\\*]/;
    return pattern.test(userInput);
}

export function checkDoubleDots(userInput) {
    const doubleDotPattern = /\.\./;
    return doubleDotPattern.test(userInput);
}

export function checkOnlyAlphaNumeric(userInput) {
    const pattern = /^[a-zA-Z0-9]+$/;
    return pattern.test(userInput);
}

export function checkValidEmail(email) {
    const pattern = /^[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*$/;
    return pattern.test(email);
}

export function checkAddress(address) {
    const pattern = /^[-#(),.\u4E00-\u9FFFa-zA-Z0-9][\u4E00-\u9FFFa-zA-Z0-9]*([ \-#(),.](?![ \-#(),.])[\u4E00-\u9FFFa-zA-Z0-9]+)*$/;
    return pattern.test(address);
}

/** 載具號碼格式檢查 */
export function checkMobileBarcode (value) {
    let regex = /^\/[0-9A-Z.+-]{7}$/;
    return value.match(regex);
}